module.exports = __webpack_public_path__ + "img/ring_y_s_1_0@3x.b2ed5643.png";